// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__J9CvP","container":"styles_container__ReCpr","title":"styles_title__1CJUT","wrapper":"styles_wrapper__1N805","answer":"styles_answer__3fFqG"};